module.exports = __webpack_public_path__ + "img/education.124f7485.svg";